import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { InstallierteLeistungAggregate } from '../../../domain/model/report/installierte-leistung-aggregate';
import { EnergieartIconService } from '../../../service/energieart/energieart-icon.service';
import { EnergieartColorService } from '../../../service/energieart/energieart-color.service';
import { EnergieartNameService } from '../../../service/energieart/energieart-name.service';
import { Leistungseinheit } from '../../../domain/model/leistungseinheit';

@Component({
    selector: 'tnb-aggregated-installierte-leistung-by-energieart',
    templateUrl: './aggregated-installierte-leistung-by-energieart.component.html',
    styleUrls: [
        './aggregated-installierte-leistung-by-energieart.component.scss',
    ],
    standalone: false,
})
export class AggregatedInstallierteLeistungByEnergieartComponent implements OnChanges {
    energieartNameService = inject(EnergieartNameService);
    private energieartColorService = inject(EnergieartColorService);
    private energieartIconService = inject(EnergieartIconService);

    @Input()
    public aggregations: InstallierteLeistungAggregate[];

    @Input()
    public leistungseinheit?: Leistungseinheit = null;
    bars = [];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.aggregations && changes.aggregations.currentValue) {
            this.bars = this.calculateBarChart(changes.aggregations.currentValue);
        }
    }

    private calculateBarChart(aggregations: InstallierteLeistungAggregate[]) {
        if (aggregations) {
            const installierteLeistungMax = aggregations.reduce((prevMax: number, aggregatem) => Math.max(prevMax, aggregatem.sum), 0);

            return aggregations.map(aggregation => {
                return {
                    percent: aggregation.sum * 100 / installierteLeistungMax,
                    color: this.energieartColorService.getColorNameForEnergieart(aggregation.energieart),
                    icon: this.energieartIconService.getIconNameForEnergieart(aggregation.energieart),
                };
            });
        }

        return [];
    }
}

